import { render } from "./ButtonGroup.vue?vue&type=template&id=3812f775"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts"

import "./ButtonGroup.vue?vue&type=style&index=0&id=3812f775&lang=scss"
script.render = render

export default script